import React, { useState } from 'react';
import { Alert, Box, Button, Stack, TextField, Typography } from '@mui/material';
import { Download, Key } from '@mui/icons-material';
import { downloadDatabaseDump, generateEncryptionKey } from '../../services/database-dump.service';
import { toastService } from '../../services/toast.service';

const KEY_PATTERN = /^[0-9a-fA-F]{64}$/;
const IDS_PATTERN = /^\s*\d+(\s*,\s*\d+)*\s*$/;

export const DevDatabaseDump: React.FC = () => {
  const [userLimit, setUserLimit] = useState('200');
  const [keepUserIds, setKeepUserIds] = useState('');
  const [encryptionKey, setEncryptionKey] = useState('');
  const [loading, setLoading] = useState(false);

  const idsError = keepUserIds.trim() !== '' && !IDS_PATTERN.test(keepUserIds);
  const limit = Number(userLimit);
  const limitError = userLimit.trim() !== '' && !(Number.isInteger(limit) && limit >= 1 && limit <= 100000);
  const keyError = encryptionKey.trim() !== '' && !KEY_PATTERN.test(encryptionKey.trim());

  const handleDownload = async () => {
    setLoading(true);
    try {
      await downloadDatabaseDump({ keepUserIds, encryptionKey, userLimit });
      toastService.success('Дамп завантажено');
    } catch {
      toastService.error('Не вдалося створити дамп');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ maxWidth: 720 }}>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Дамп MySQL для розробки (.sql.gz). Маскуються email, імена, телефони, аватари, паролі (у всіх — Test1234!),
        контакти в профілі, токени, платіжні відповіді, тексти чату й сповіщень. Сесії, пристрої, платіжні й
        планувальника логи — без даних. MongoDB не входить.
      </Typography>
      <Stack spacing={2}>
        <TextField
          label="Кількість користувачів"
          type="number"
          value={userLimit}
          onChange={(e) => setUserLimit(e.target.value)}
          error={limitError}
          helperText={limitError ? 'Ціле число від 1 до 100000' : 'Перші N користувачів (за ID) з їхніми даними; порожньо — 200'}
        />
        <TextField
          label="ID користувачів без маскування"
          placeholder="12, 45"
          value={keepUserIds}
          onChange={(e) => setKeepUserIds(e.target.value)}
          error={idsError}
          helperText={idsError ? 'Числа через кому' : 'Дані цих користувачів — в оригіналі (email, ім\'я, пароль); входять у дамп понад ліміт'}
        />
        <Stack direction="row" spacing={1} alignItems="flex-start">
          <TextField
            fullWidth
            label="Ключ шифрування дампу"
            placeholder="порожньо — стандартний ключ дампу"
            value={encryptionKey}
            onChange={(e) => setEncryptionKey(e.target.value)}
            error={keyError}
            helperText={keyError ? '64 шістнадцяткові символи' : 'Цей ключ ставиться в PII_ENCRYPTION_KEY локального .env'}
            inputProps={{ spellCheck: false }}
          />
          <Button startIcon={<Key />} onClick={() => setEncryptionKey(generateEncryptionKey())} sx={{ mt: 0.5, whiteSpace: 'nowrap' }}>
            Згенерувати
          </Button>
        </Stack>
        <Alert severity="info">
          Створення займає кілька хвилин: таблиці з векторами пошуку (їжа, MET) — найбільші.
        </Alert>
        <Box>
          <Button variant="contained" startIcon={<Download />} onClick={handleDownload} disabled={loading || idsError || keyError || limitError}>
            {loading ? 'Створюю дамп…' : 'Завантажити дамп'}
          </Button>
        </Box>
      </Stack>
    </Box>
  );
};
